import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { SearchView } from "@containers/search/SearchView";

const SearchSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="search" searchPage>
            <SearchView />
        </AuthenticatedLayout>
    );
}

export default SearchSessionsPage;